<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    name: "PropertyCart",
    components: {
        RawData,
    },
    props: {
        cartItems: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        modalTitle() {
            return `Cart: ${this.cartItems.length} ${this.cartItems.length > 1 ? 'Properties' : 'Property'}`;
        },
        filtered() {
            let data = this.cartItems;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey.toLowerCase().includes(this.filter.toLowerCase());
                });
            }
            return data;
        },
        isPAR(){
            return this.checkPropertyType(this.filtered) == 1 || this.checkPropertyType(this.filtered) == 3;
        },
        isICS(){
            return this.checkPropertyType(this.filtered) == 2 || this.checkPropertyType(this.filtered) == 3;
        },  
        rowsCart() {
            if (this.filter.trim() != "" && this.filter) {
                return this.filtered.length;
            } else {
                return this.cartItems.length;
            }
        },
        rowCartString() {
            return `Showing ${(this.currentPage - 1) * this.perPage + 1} -
            ${
                this.rowsCart > (this.currentPage - 1) * this.perPage + this.perPage
                ? (this.currentPage - 1) * this.perPage + this.perPage
                : this.rowsCart
            } of ${this.rowsCart}`;
        },
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: 5,
            propertyFields: [
                {
                    key: "Name",
                    sortable: true
                }
            ],
            sortDesc: false,   
        }
    },
    methods: {
        checkPropertyType(row) {
            var PAR = 0;
            var ICS = 0;
            row.forEach((item) => {
                if (item.amount >= 50000) PAR++;
                else ICS++;
            });
            if (PAR == 0 && ICS == 0) return 0;
            else if (PAR > 0 && ICS == 0) return 1;
            else if (PAR == 0 && ICS > 0) return 2;
            else if (PAR > 0 && ICS > 0) return 3;
        },
        propertyNumberWidth(number) {
            if (number < 100) return "min-width: 35px";
            else if (number < 1000) return "min-width: 50px";
            else if (number < 10000) return "min-width: 60px";
            else return "min-width: 75px";
        },
        propertyStyle(row, cPage, pPage) {
            return this.propertyNumberWidth((cPage - 1) * pPage + (row.index + 1))
        },
    }
}
</script>
<template>
    <b-modal 
        id="modal-cart" 
        :title="modalTitle"
        size="xl" 
        title-class="font-18" 
        hide-footer 
        no-close-on-backdrop
    >
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex justify-content-between align-items-center">
                <b-dropdown 
                    id="dropdown-bottom" 
                    right 
                    variant="link" 
                    toggle-class="text-decoration-none p-0"
                    menu-class="dropdown-menu-bottom" 
                    no-caret
                >
                    <template #button-content>
                        <button type="button" class="btn btn-sm btn-purple d-flex align-items-center justify-content-center me-1">
                            <i class="bx bx-printer fs-6 me-1"></i>Print Documents
                        </button>
                    </template>
                    <b-dropdown-item 
                        v-if="isPAR" 
                        @click="printParMultiple()"
                    >
                        <i class="bx bx-printer font-size-18 text-purple me-1"></i>
                        Print PAR
                    </b-dropdown-item>
                    <b-dropdown-item 
                        v-if="isICS" 
                        @click="printIcsMultiple()"
                    >
                        <i class="bx bx-printer font-size-18 text-purple me-1"></i>
                        Print ICS
                    </b-dropdown-item>
                    <b-dropdown-item @click="printStickerMultiple()">
                        <i class="bx bx-printer font-size-18 text-purple me-1"></i>
                        Print Sticker
                    </b-dropdown-item>
                </b-dropdown>
                <b-dropdown 
                    id="dropdown-bottom" 
                    right 
                    variant="link" 
                    toggle-class="text-decoration-none p-0"
                    menu-class="dropdown-menu-bottom" 
                    no-caret
                >
                    <template #button-content>
                        <button type="button"
                            class="btn btn-sm btn-success d-flex align-items-center justify-content-center me-1">
                            <i class="bx bx-right-arrow-circle fs-6 me-1"></i>Actions
                        </button>
                    </template>
                    <b-dropdown-item @click="addInventory()">
                        <i class="bx bx-box font-size-18 text-success me-1"></i>
                        Add to Inventory
                    </b-dropdown-item>
                    <b-dropdown-item @click="transferCampus()">
                        <i class="bx bx-transfer font-size-18 text-primary me-1"></i>
                        Transfer {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                    </b-dropdown-item>
                    <b-dropdown-item @click="transferMultipleItems()">
                        <i class="bx bx-user font-size-18 text-info me-1"></i>
                        Transfer Assignment
                    </b-dropdown-item>
                    <b-dropdown-item @click="returnMultipleItems()">
                        <i class="bx bx-revision font-size-18 text-warning me-1"></i>
                        Return Items
                    </b-dropdown-item>
                </b-dropdown>
                <b-dropdown 
                    id="dropdown-dropleft" 
                    right 
                    variant="info" 
                    toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end" 
                    size="sm" no-caret
                >
                    <template #button-content>
                        <div class="d-flex align-items-center">
                            <i class="bx bx-edit fs-6 me-1"></i>Update Selected
                        </div>
                    </template>
                    <b-dropdown-item 
                        @click="changeItemCategory()" 
                        variant="info"
                    >
                        <i class="mdi mdi-format-list-text font-size-18 me-1"></i>
                        Change Category
                    </b-dropdown-item>
                    <b-dropdown-item 
                        @click="changeDateAcquired()" 
                        variant="info"
                    >
                        <i class="mdi mdi-calendar-month font-size-18 me-1"></i>
                        Change Date Acquired
                    </b-dropdown-item>
                    <b-dropdown-item 
                        @click="changeDateAssigned()" 
                        variant="info"
                    >
                        <i class="mdi mdi-calendar-account-outline font-size-18 me-1"></i>
                        Change Date Assigned
                    </b-dropdown-item>
                    <b-dropdown-item 
                        @click="changeUnitCost()" 
                        variant="info"
                    >
                        <i class="mdi mdi-cash-multiple font-size-18 me-1"></i>
                        Change Unit Cost
                    </b-dropdown-item>
                    <b-dropdown-item 
                        @click="changeLocation()" 
                        variant="info"
                    >
                        <i class="mdi mdi-map-marker font-size-18 me-1"></i>
                        Change Location
                    </b-dropdown-item>
                    <b-dropdown-item 
                        @click="changeCondition()" 
                        variant="info"
                    >
                        <i class="mdi mdi-clipboard-edit-outline font-size-18 me-1"></i>
                        Change Condition
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="d-flex align-items-center">
                <b-button 
                    title="Remove All from Cart" 
                    class="me-2" 
                    @click="clearCart()" 
                    variant="outline-danger"
                >
                    <i class="mdi mdi-cart-remove"></i>
                </b-button>
                <b-form-input 
                    autocomplete="off" 
                    v-model="filter" 
                    type="search" 
                    @input="currentPage = 1"
                    placeholder="Search Properties..." 
                    class="form-control"
                ></b-form-input>
            </div>
        </div>
        <div class="custom-table-responsive mb-0">
            <b-table 
                class="propertyTable datatables target-table" 
                thead-class="d-none" 
                :items="filtered"
                :fields="propertyFields" 
                responsive="sm" 
                :per-page="perPage" 
                :current-page="currentPage" 
                sort-by="id"
                :sort-desc.sync="sortDesc" 
                :busy="false" 
                show-empty
            >
                <template #empty>
                    <b-card-header>
                        <div class="text-center">
                            <div v-if="filter != ''">
                            <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching your request
                            </div>
                            <div v-else>
                            <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                            </div>
                        </div>
                    </b-card-header>
                </template>
                <template #table-busy>
                    <b-card-header>
                        <div class="d-flex justify-content-center align-items-center p-2">
                            <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                </div>
                            </div>
                            </div>
                            <strong>Loading...</strong>
                        </div>
                    </b-card-header>
                </template>
                <template #cell(name)="propertyRow">
                    <div class="position-relative ms-1">
                        <RawData 
                            :data="propertyRow.item" 
                            :keyId="`cart-${propertyRow.item.id}`"
                            v-if="$store.state.decrypt.isAdmin()" 
                        />
                        <b-card-header header-tag="header" role="tab" class="border">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center pe-5">
                                    <div :style="propertyStyle(propertyRow, currentPage, perPage)"
                                        class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                        <h3 class="mb-0 position-relative">
                                        {{
                                            (currentPage - 1) * perPage +
                                            (propertyRow.index + 1)
                                        }}
                                        </h3>
                                    </div>
                                    <div class="text-muted">
                                        <h5 class="mb-0">
                                        {{ propertyRow.item.name }}
                                        </h5>
                                        <div>
                                        <small class="d-flex align-items-center">{{
                                            propertyRow.item.propertyNumber &&
                                            propertyRow.item.propertyNumber != "Not Indicated"
                                            ? `Property# ${propertyRow.item.propertyNumber}`
                                            : "Not Indicated"
                                        }}
                                        </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center ms-5">
                                    <div style="width: 200px" class="d-flex align-items-center">
                                        <div class="text-muted">
                                            <div>
                                                <small class="d-flex align-items-center">
                                                Current Value:
                                                </small>
                                            </div>
                                            <h6 class="mb-0 text-warning">
                                                {{ formatCurrency(propertyRow.item.currentValue) }}
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="float-end d-flex align-items-center ms-3">
                                        <i title="Remove From Cart" class="bx bx-x font-size-18 text-danger cursor-pointer ms-2 me-2"
                                        @click="removeFromCart(propertyRow.item)"></i>
                                    </div>
                                </div>
                            </div>
                        </b-card-header>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row my-2">
            <div v-if="rowsCart" class="col">
                {{ rowCartString }}
            </div>
            <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="rowsCart" :per-page="perPage"></b-pagination>
                </ul>
            </div>
            </div>
        </div>
    </b-modal>
</template>